<script>
import SelectWithSearch from '@/views/pages/Dilfoods/Common/SelectWithSearch.vue';
import {GravyPath,BrandsPath,OpsPath} from '@/path';
import Swal from 'sweetalert2';
import axios from 'axios';
    export default {
        components : {SelectWithSearch},
        props : ['gravies','option'],
        data(){
            return{
                fields : ['gravy','gm_usage','brand','actions'],
                current_page : 1,
                base_url : process.env.VUE_APP_API_BACKEND_URL,
                form : {
                    op_id : this.option?.id,
                    gravy_id : null,
                    brand_ids : []
                },
                selectedGravy : null,
                key : 1,
            }            
        },
        computed : {
            GravyPath(){
                return GravyPath;
            },
            BrandsPath(){
                return BrandsPath;
            }
        },
        methods : {
            async saveGravy(){
                try {
                    let res = await axios.post(this.base_url + OpsPath.SAVEOPSGRAVY,this.form);
                    if(res.data.status){
                        this.form = {};
                        Swal.fire("Updated Successfully","","success");
                        this.gravies.push(res.data.data);
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            setGravy(v){
                this.form.gravy_id = v.id;
                this.selectedGravy = v;
                this.key += 1;
            },
            async deleteRow(row){
                try {
                    let res = await axios.post(this.base_url + OpsPath.DELETEOPSGRAVY,{
                        gravy_id : row.item.gravy_id,
                        brand_id : row.item.brand_id,
                        op_id : row.item.op_id,
                        usage : row.item.gm_usage                   
                    });
                    if(res.data.status){
                        Swal.fire("Deleted Successfully","","success");
                        this.gravies = this.gravies.filter((f,fi) => fi !== row.index);
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        }
    }
</script>

<template>
    <div>        
        <div>
            <b-row>
                <b-col sm="4">
                    <label>Gravy</label>
                    <SelectWithSearch :search_api="GravyPath.SEARCH_GRAVIES" track_by="id" display="name" @selectedOption="setGravy" :full_object="true"></SelectWithSearch>
                </b-col>
                <b-col sm="4">
                    <label :key="key">Usage ({{ selectedGravy?.units }})</label>
                    <b-input v-model="form.usage" type="number"></b-input>
                </b-col>                
                <b-col sm="4">
                    <label>Brands</label>                    
                    <SelectWithSearch :search_api="BrandsPath.BRAND_SEARCH" track_by="id" display="label" @selectedOption="((v) => form.brand_ids = v)" :multi_select="true"></SelectWithSearch>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button variant="success" @click="saveGravy">Save</b-button>
                </b-col>
            </b-row>
        </div>
        <b-table
            :key="gravies.key"
            :items="gravies"
            :fields="fields"
            :per-page="10"
            responsive="sm"
            :current-page="current_page"
        >
            <template v-slot:cell(gravy)="row">
                {{ row.item.gravy_name }}                
            </template>
            <template v-slot:cell(brand)="row">
                {{ row.item.brand_name }}
            </template>
            <template v-slot:cell(gm_usage)="row">
                {{ row.item.gm_usage }} {{ row.item.units }}
            </template>
            <template v-slot:cell(actions)="row">
                <b-button variant="danger" @click="deleteRow(row)"><i class="fa fa-trash"></i></b-button>
            </template>
        </b-table>
        <div class="row">
            <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">                
                    <b-pagination :key="gravies.key" v-model="current_page" :total-rows="gravies.length" :per-page="10"></b-pagination>
                </ul>
            </div>
            </div>
        </div>
    </div>
</template>

<style>
    
</style>